import Checkbox, { CheckboxProps } from "@ui-kit/form/Checkbox/Checkbox.web";
import React from "react";
import Box from "@shared/components/ui-kit/layout/Box/Box.web";
import type { ListItemSelectorSharedProps } from "./ListItemSelector.props";

// Variant configurations for the container box styling
const boxVariants = {
  primary: {
    checked: {
      borderColor: "blue.800",
      backgroundColor: "blue.100",
    },
    label: {
      default: "fg",
      checked: "blue.800",
    },
    colorPalette: "blue" as const,
  },
  secondary: {
    checked: {
      borderColor: "primary.solid",
      backgroundColor: "bg",
    },
    label: {
      default: "fg",
      checked: "fg",
    },
    colorPalette: "primary" as const,
  },
};

export type ListItemSelectorProps = ListItemSelectorSharedProps &
  CheckboxProps & {
    // Add any web-specific props here.
  };

const ListItemSelector: React.FC<ListItemSelectorProps> = ({
  isDisabled = false,
  handleChange,
  checkboxLabel,
  variant = "primary",
  border = "1px solid",
  mb = "20px",
  isChecked,
  ...props
}): JSX.Element => {
  const variantStyles = boxVariants[variant];

  return (
    <Box
      as="label"
      display="flex"
      alignItems="flex-start"
      cursor={isDisabled ? "not-allowed" : "pointer"}
      mb={mb}
      w="100%"
      p="md"
      border={border}
      borderColor={isChecked ? variantStyles.checked.borderColor : "border"}
      backgroundColor={isChecked ? variantStyles.checked.backgroundColor : "bg"}
      borderRadius={{ base: "sm", sm: "md" }}
      opacity={isDisabled ? 0.6 : 1}
      transition="all 0.2s"
      _hover={
        !isDisabled
          ? { borderColor: variantStyles.checked.borderColor }
          : undefined
      }
    >
      <Checkbox
        {...props}
        isDisabled={isDisabled}
        isChecked={isChecked}
        size="lg"
        colorPalette={variantStyles.colorPalette}
        onChange={(e) => handleChange(e)}
        width="100%"
        css={{
          "& [data-part='label']": {
            color: isChecked
              ? variantStyles.label.checked
              : variantStyles.label.default,
            marginInlineStart: "16px",
            flex: 1,
            minWidth: 0,
          },
        }}
      >
        {checkboxLabel}
      </Checkbox>
    </Box>
  );
};
export default ListItemSelector;
